const getStepPosition = (stepKey, activeStep) => {
  if (stepKey === activeStep) return 'is-active';
  return stepKey < activeStep ? 'is-complete' : 'is-upcoming';
};

export const getStepClassName = (stepKey, activeStep, hasError) => {
  const position = getStepPosition(stepKey, activeStep);
  return hasError ? `${position} has-error` : position;
};
